import React from "react";
import "./style.scss";

/*
 * The confirm / alert card used across the Push Notification pages, built on the Figma .nc-dialog:
 * one size, a left-aligned sentence-case heading, an optional body, and a right-aligned button row.
 *
 * `actions` is rendered left-to-right, so the dismissing action comes first and the main one last;
 * mark the main one `primary`. Each action is { label, onClick, primary?, autoFocus? }. Keeping the
 * single source here means the "Discard unsaved changes?" prompt and every Delete / Cancel confirm
 * share one look and one left/right button convention.
 */
export default function ConfirmDialog({ title, labelId, children, actions, onDismiss }) {
  return (
    <div
      className="nc-dialog-backdrop"
      onMouseDown={event => {
        if (event.target === event.currentTarget && onDismiss) {
          onDismiss();
        }
      }}
    >
      <section role="dialog" aria-modal="true" aria-labelledby={labelId} className="nc-dialog">
        <h2 id={labelId} className="nc-dialog-title">
          {title}
        </h2>
        {children ? <div className="nc-dialog-body">{children}</div> : null}
        <div className="nc-dialog-actions">
          {(actions || []).map((action, index) => (
            <button
              key={`dialog-action-${index}`}
              type="button"
              className={action.primary ? "nc-dialog-btn primary" : "nc-dialog-btn"}
              autoFocus={action.autoFocus}
              onClick={action.onClick}
            >
              {action.label}
            </button>
          ))}
        </div>
      </section>
    </div>
  );
}
